import React, { useEffect } from 'react';
import RetailOrderGrid from '../../../features/cfi/retail-order-grid/components/RetailOrderGrid';
import { useTitle } from "../../../contexts/title";

export default function VanityOrdersPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Vanity Orders')
	}, [pageTitle]);

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<RetailOrderGrid
					vanityOrders={true}
					backOrders={false}
				/>
			</div>
		</React.Fragment>
	)
} 
